import { useLayoutEffect, type EffectCallback } from 'react';

export const useLayoutEffectOnce = (effect: EffectCallback) => {
  useLayoutEffect(effect, []); // eslint-disable-line react-hooks/exhaustive-deps
};
